import React from 'react';
import PropTypes from 'prop-types';
import { HeadingArticle } from '../../design-system/Headings';
import LaserBannerPageSection from '../../design-system/LaserBannerPageSection';
import Paragraph from '../../design-system/Paragraph';

export default function TheScienceSection({
  title,
  description,
  linkPath,
  linkText,
}) {
  return (
    <LaserBannerPageSection borderT>
      <HeadingArticle el="h2">{title}</HeadingArticle>
      <Paragraph body secondary>
        {description}
      </Paragraph>
      <Paragraph body pySm>
        <span className="ss_pos--center ss_tt--uppercase">
          {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
          <a href={linkPath}>{linkText} →</a>
        </span>
      </Paragraph>
    </LaserBannerPageSection>
  );
}

TheScienceSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  linkPath: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
};
